import jwtDecode from "jwt-decode";
export default class TokenStore {
  static #ACCESS_STORE = "access-token";
  static #REFRESH_STORE = "refresh-token";
  #expiration;
  #onRefreshToken;
  #refreshInterval;
  #expireWindow;
  #interval;
  #onError;
  #accessToken;
  #refreshToken;

  //TODO: Change to private methods, Private functions not yet supported on CRA,using _ to signify private
  get _accessToken() {
    return this.storage.getItem(TokenStore.#ACCESS_STORE);
  }

  set _accessToken(token) {
    this.storage.setItem(TokenStore.#ACCESS_STORE, token);
  }

  get _refreshToken() {
    return this.storage.getItem(TokenStore.#REFRESH_STORE);
  }

  set _refreshToken(token) {
    this.storage.setItem(TokenStore.#REFRESH_STORE, token);
  }

  constructor({
    onRefreshToken,
    onError = () => {},
    refreshInterval = 10000, // 10s
    expireWindow = 300000, // 5min
  }) {
    this.#onRefreshToken = onRefreshToken;
    this.#refreshInterval = refreshInterval;
    this.#expireWindow = expireWindow;
    this.#onError = onError;

    if (localStorage.getItem(TokenStore.#REFRESH_STORE)) {
      this.storage = localStorage;
    } else {
      this.storage = sessionStorage;
    }

    this._expiration();
    this._initRefresh();
  }

  _migrateStorage(storage) {
    const accessToken = this._accessToken; //persist current tokens
    const refreshToken = this._refreshToken;
    this.storage.clear();
    this.storage = storage; //Change storage
    this._accessToken = accessToken; //Migrate tokens
    this._refreshToken = refreshToken;
    this._expiration();
    this._initRefresh();
  }

  enablePersistence() {
    this._migrateStorage(localStorage);
  }

  disablePersistence() {
    this._migrateStorage(sessionStorage);
  }

  setToken(token) {
    if (token) {
      this._accessToken = token;
      this._expiration();
    }
  }

  setRefreshToken(refreshToken) {
    if (refreshToken) {
      this._refreshToken = refreshToken;
      this._initRefresh();
    }
  }

  getToken() {
    return this.hasTokenExpired() ? undefined : this._accessToken;
  }

  willTokenExpire() {
    return this.#expiration - Date.now() <= this.#expireWindow;
  }

  hasTokenExpired() {
    return isNaN(this.#expiration) || this.#expiration - Date.now() <= 0;
  }

  _expiration() {
    try {
      if (this._accessToken) {
        this.#expiration = jwtDecode(this._accessToken).exp * 1000;
      }
    } catch {
      this.#onError();
    }
  }

  _initRefresh() {
    this._stopRefresh();
    if (this._refreshToken) {
      this.#interval = setInterval(() => {
        if (this.willTokenExpire()) {
          this.refreshToken();
        }
      }, this.#refreshInterval);
    }
  }

  _stopRefresh() {
    clearInterval(this.#interval);
  }

  clearTokens() {
    this._stopRefresh();
    this.storage.clear();
    this._expiration();
  }

  async refreshToken() {
    if (this._refreshToken) {
      try {
        const accessToken = await this.#onRefreshToken(this._refreshToken);
        this.setToken(accessToken);
        return accessToken;
      } catch {
        this.#onError();
      }
    } else {
      this.clearTokens();
      return false;
    }
  }
}
